import { FormattedMessage } from 'react-intl'

export default function Shared({
  numberOfProducts,
  roomTitle,
  numberOfGuests,
  sharedHandler,
  setIsCollapsed,
}) {
  return (
    <div>
      <p className='mbn'>
        <span>
          {numberOfProducts === 1 && (
            <FormattedMessage
              id='default_occupancy'
              defaultMessage='The default occupancy for 1 guest in the {roomTitle} is'
              values={{ roomTitle }}
            />
          )}
          {numberOfProducts > 1 && (
            <FormattedMessage
              id='shared_occupacy_for_more'
              defaultMessage='You have chosen to book a trip for {numberOfGuests} guests. Given the maximum occupancy levels of the chosen cabin(s), 1 guest will be booked in a cabin with the option'
              values={{ numberOfGuests }}
            />
          )}
          &nbsp;
          <span className='bold'>
            <FormattedMessage defaultMessage='Shared occupancy.' />
          </span>
          {numberOfProducts === 1 && (
            <FormattedMessage
              id='for_one_guest_description'
              defaultMessage='This means that you will most likely be paired with another guest with whom you will share the cabin. That other guest may or may not be of the same gender as you.'
              tagName='p'
            />
          )}
          {numberOfProducts > 1 && (
            <FormattedMessage
              id='for_multi_guests_description'
              defaultMessage='This means that you will be paired with another guest of the same sex with whom you will share the cabin.'
              tagName='p'
            />
          )}
        </span>
      </p>
      <div className='buttons'>
        <button className='btn-red' onClick={() => sharedHandler(false)}>
          <FormattedMessage
            defaultMessage='Yes I want the cabin to myself'
            id='want_to_myself'
          />
        </button>
        <span onClick={() => setIsCollapsed(true)}>
          <FormattedMessage
            defaultMessage={`No thanks, I'm fine with sharing`}
            id='stay_with_sharing'
          />
        </span>
      </div>
    </div>
  )
}
